import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgCheckIn = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    stroke="#4D4D4D"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M8 16.871V7.903m0 0 3.393 3.394M7.999 7.903l-3.393 3.394m6.517 3.126h3.133v-8.65L8 1.384h-.018l-6.255 4.39v8.65h3.132" />
  </svg>
);
const Memo = memo(SvgCheckIn);
export default Memo;
